import { render } from "./pdf-reader-iframe.vue?vue&type=template&id=518a0c6e&scoped=true"
import script from "./pdf-reader-iframe.vue?vue&type=script&lang=js"
export * from "./pdf-reader-iframe.vue?vue&type=script&lang=js"

import "./pdf-reader-iframe.vue?vue&type=style&index=0&id=518a0c6e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-518a0c6e"]])

export default __exports__